import React, { useState, useEffect } from 'react'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import { Input, InputGroup, Panel } from 'rsuite'
import { Row, Col, SelectPicker, Icon } from 'rsuite'
import { useForm, Controller } from 'react-hook-form'
import ButtonPanelWidget from '../ButtonPanelWidget'

export default function SearchUserSubProjectWidgets(props) {
  const { isError, isLoading, onSubmit, onCancel } = props
  const [formSchema, setFormSchema] = useState(props.schema)
  const [disabledValue, setDisableValue] = useState({})
  const [userName, setUserName] = useState()
  const [statusOption, setStatusOption] = useState()

  return (
    <>
      <Panel shaded header={formSchema.header} collapsible defaultExpanded>
        <Row>
          {formSchema?.userName && (
            <>
              <Col
                lg={4}
                md={4}
                sm={4}
                xs={4}
                style={{ marginTop: '5px', padding: '8px', textAlign: 'right' }}
              >
                {formSchema.userName.label}
              </Col>
              <Col lg={8} md={8} sm={8} xs={8} style={{ marginTop: '5px', padding: '8px' }}>
                <Input
                  name={formSchema.userName.name}
                  value={userName}
                  placeholder={formSchema.userName.hint || `ระบุ${formSchema.userName.label}`}
                  onChange={(value) => {
                    setUserName(value)
                  }}
                />
              </Col>
            </>
          )}

          {formSchema?.statusOption && (
            <>
              <Col
                lg={4}
                md={4}
                sm={4}
                xs={4}
                style={{ marginTop: '5px', padding: '8px', textAlign: 'right' }}
              >
                {formSchema.statusOption.label}
              </Col>
              <Col lg={8} md={8} sm={8} xs={8} style={{ marginTop: '5px', padding: '8px' }}>
                <SelectPicker
                  data={formSchema.statusOption.options}
                  disabled={disabledValue.statusOption}
                  searchable={false}
                  value={statusOption}
                  block
                  placeholder="เลือก"
                  onChange={(value) => {
                    console.log('value', value)
                    setStatusOption(value)
                  }}
                />
              </Col>
            </>
          )}
        </Row>

        <hr />

        <ButtonPanelWidget
          isDisabled={formSchema.buttonText.disabled || isLoading}
          isEdit={true}
          isError={isError}
          buttonText={formSchema.buttonText}
          onSave={(el) => {
            onSubmit({
              userName: userName,
              status: statusOption || 0,
            })
          }}
          onCancel={(el) => {
            setUserName('')
            setStatusOption('')
            onCancel()
          }}
        />
      </Panel>
    </>
  )
}
